import apiClient from "../api/apiClient";

// Fetches `url` through apiClient (so the Authorization header is attached)
// and triggers a browser download of the response body using `filename`.
export async function downloadFromApi(url, filename) {
    const res = await apiClient.get(url, { responseType: "blob" });
    if (filename.toLowerCase().endsWith(".pdf")) {
        const signature = await res.data.slice(0, 5).text();
        if (signature !== "%PDF-") {
            throw new Error("The server did not return a PDF. Restart the backend to load the latest routes, then try again.");
        }
    }
    const blobUrl = URL.createObjectURL(res.data);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove(); 
    URL.revokeObjectURL(blobUrl);
}
